module.exports = __webpack_public_path__ + "static/media/cf.c96449fa.svg";